import Script from 'next/script';
import { useGlobal } from '@/utils/useGlobal';

const localeMapKey: any = {
    ca: 'aa2748fa-0264-4264-b368-930a6a532691',
    us: '02f09d76-597b-45ea-957b-5a7aa1eb9ca9',
    jp: 'f0fdbb97-c08e-4314-a158-2ee372b5c10b',
    au: '6c02b093-30d8-486f-94e9-72c84bbc404c',
};

/**
 * @description: Zendesk 客服机器人
 */
export default function ChatBox({ locale }: any) {
    const allowLangs = ['us', 'jp', 'au'];
    const { useState, useRouter, useEffect, isMobile, isCypressTest } = useGlobal();
    const { asPath } = useRouter();
    const isMM100 = asPath.includes('ecoflow-power-kits/series');
    const [interObserver, setInterObserver] = useState(null);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (!allowLangs.includes(locale)) return;
        if (isMobile) return;
        if (interObserver) interObserver.disconnect();
        setInterObserver(
            new IntersectionObserver((entry: IntersectionObserverEntry[]) => {
                const calIconStatus = entry[0].intersectionRatio <= 0 && entry[0].boundingClientRect.y < 0;
                calIconStatus ? handleZEzIndex('show') : handleZEzIndex('hide');
            }),
        );
        return () => {
            interObserver && interObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        const target = document.querySelector('.help-choose') as Element;
        if (target && load && interObserver) {
            interObserver.observe(target);
        }
    }, [interObserver, load]);

    const handleZEzIndex = (type: string) => {
        if (isCypressTest) {
            return;
        }
        (window.zE as any) && (window.zE as any)('webWidget', type);
    };

    if (!allowLangs.includes(locale)) return <></>;

    return (
        <>
            <Script
                strategy="lazyOnload"
                id="ze-snippet"
                src={`https://static.zdassets.com/ekr/snippet.js?key=${localeMapKey[locale] || localeMapKey['us']}`}
                onLoad={() => setLoad(true)}
            />
            <style jsx global>
                {`
                    style + iframe[style*='webSDKOnLoad'] {
                        transform: scale(0.625, 0.625) !important;
                        transform-origin: top right;
                        right: 22px !important;
                        bottom: 170px !important;
                        ${isMM100 ? 'display:block !important;' : ''}
                        ${locale == 'au' ? 'bottom: 170px !important;left: 20px !important;transform-origin: top left;' : ''}
                    }
                    style + iframe[style*='webSDKOnLoad'] + iframe {
                        right: 22px !important;
                        bottom: 220px !important;
                        ${locale == 'au' ? 'bottom: 220px !important;left: 20px !important;' : ''}
                    }
                    body .acsb-trigger.acsb-trigger-size-small,
                    body .acsb-trigger.acsb-trigger-size-medium {
                        ${isMM100 ? 'display:none !important;' : ''}
                    }
                `}
            </style>
        </>
    );
}
